import { downloadAssets } from "@/client";
import { tryShareURL } from "~/modules/shared/utils/shareURL";
import { triggerFileDownload } from "~/modules/shared/utils/triggerFileDownload";
import type { VideoEvidence } from "../../ChatEventTypes";

function clipZipFilename(title: string | null | undefined): string {
	const base = (title?.trim() || "clip")
		.replace(/[^\w\s-]/g, "")
		.replace(/\s+/g, "-")
		.slice(0, 100);
	return `${base}.zip`;
}

async function downloadClipViaApi(
	clip: VideoEvidence,
	boardId: string,
): Promise<void> {
	const response = await downloadAssets({
		path: { board_id: boardId },
		body: { clip_ids: [clip.video_id] },
		parseAs: "blob",
	});

	if (response.error) {
		const message =
			(response.error as { message?: string }).message ??
			"Failed to download clip";
		throw new Error(message);
	}

	triggerFileDownload(response.data, clipZipFilename(clip.title));
}

export async function shareOrDownloadClip(
	clip: VideoEvidence,
	boardId?: string,
): Promise<void> {
	try {
		const shared = await tryShareURL({
			title: clip.title ?? "Clip",
			url: clip.post_url?.trim() || window.location.href,
		});
		if (shared) {
			return;
		}
	} catch (error) {
		if (error instanceof DOMException && error.name === "AbortError") {
			return;
		}
	}

	if (boardId) {
		await downloadClipViaApi(clip, boardId);
	}
}
